import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";

import Requirements from "./Requirements";
import "./FrontPage.css";

class FrontPage extends Component {
  scrollTo = el => {
    switch (el) {
      case "promo":
        this.promoSection.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
        break;
      default:
    }
  };

  render() {
    return (
      <div className="front-page">
        <div className="hero">
          <img width="300" alt="Pronounce Live" src="white-logo.png" />
          <h2>Perfect your pronunciation</h2>
          <RaisedButton
            labelColor="#fff"
            backgroundColor="#31C04C"
            onClick={() => {
              this.scrollTo("promo");
            }}
            label="Learn More"
          />
          <br />
          <br />
        </div>
        <div
          className="promo-content dark"
          ref={el => {
            this.promoSection = el;
          }}
        >
          <div className="section dark">
            <div className="half-section">
              <h3>
                Pronounce Live boosts your confidence in speaking a foreign
                language.
              </h3>
              <p>
                Pronounce Live is a web application for pronunciation practice.
                You can listen to authentic speech models read any text or
                words, record your own voice for comparison and receive
                immediate feedback.
              </p>
              <p>Perfect your pronunciation and practice for life!</p>
            </div>
            <div className="half-section">
              <img
                className="img-responsive promo-laptop"
                alt="Pronounce Live running on a laptop"
                src="/images/frontpage-laptop.png"
              />
              <Requirements />
            </div>
          </div>
        </div>

        <div className="wrapper white">
          <div className="section">
            <div className="half-section">
              <h3>Uno Dos Tres</h3>
              <p>
                {" "}
                1. <strong>Listen</strong> to an authentic speech model read the
                model word or sentence
                <br />
                <br />
                2. <strong>Record</strong> yourself speaking the same text
                <br />
                <br />
                3. <strong>Review</strong> your performance with automatic
                scoring
              </p>
            </div>
            <div className="half-section">
              <img
                className="img-responsive align-with-laptop"
                alt="Pronounce Live icons"
                src="/images/frontpage-control-icons.png"
              />
            </div>
          </div>
        </div>

        <div className="wrapper grey">
          <div className="section">
            <div className="half-section">
              <img
                className="img-responsive"
                alt="Pronounce Live results"
                src="/images/frontpage-results.png"
              />
            </div>
            <div className="half-section">
              <h3>Improve with instant feedback</h3>
              <p>
                Color coding will mark words to focus on, and you also get an
                overall score for your pronunciation. Compete against yourself,
                the perfect score is only a syllable away!
              </p>
            </div>
          </div>
          <div className="wrapper blue">
            <div className="section">
              <div className="half-section">
                <h3>Create your own exercises</h3>
                <p>
                  Use any content that suits your personal goals best - just
                  copy and paste it and Pronounce Live will automatically divide
                  the text into exercise sentences for you to practice with.
                </p>
              </div>
              <div className="half-section">
                <img
                  className="img-responsive align-with-laptop"
                  alt="Pronounce Live results"
                  src="/images/Copy.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FrontPage;



// WEBPACK FOOTER //
// ./src/components/FrontPage.js